import $ from 'wee-dom';
import $events from 'wee-events';
import $screen from 'wee-screen';
import $location from 'wee-location';
import { RouteHandler } from 'wee-routes';

function toggleLoginNav() {
	$('.login').toggleClass('-active');
	$('.login-nav').toggleClass('-active');
}

export default new RouteHandler({
	init() {
		const $cart = $('.cart');

		$events.on({
			'.login': {
				click: (e, el) => {
					toggleLoginNav();
				},
				keydown: (e, el) => {
					if (e.keyCode === 13) {
						toggleLoginNav();
					}

					if (e.keyCode === 27 && $('.login-nav').hasClass('-active')) {
						toggleLoginNav();
					}
				}
			}
		});

		$screen.map([
			{
				max: 3,
				callback() {
					$('.header__content').after($cart);
				}
			},
			{
				min: 4,
				callback() {
					$('.topbar-content').append($cart);
					$('.header__container').prepend($('.topbar-content'));
				}
			}
		]);
	}
});